import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

export default function Firstpage() {
  const { t } = useTranslation();
  const navigate=useNavigate()
  const [rippleStyle, setRippleStyle] = useState({});
  const [isAnimating, setIsAnimating] = useState(false);

  const handleMouseEnter = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    setRippleStyle({
      top: y,
      left: x,
    });
    setIsAnimating(true);
  };

  const handleClick = (e) => {
    navigate('/contact')
    handleMouseEnter(e);
  };

  const handleMouseLeave = () => {
    setIsAnimating(false);
  };

  return (
    <div className="flex h-full lg:h-[45rem] flex-col items-center w-full">
      {/* Content Wrapper */}
      <div className="flex flex-col lg:flex-row items-start w-full max-w-7xl px-4 py-8 h-full relative">
        {/* Left Section */}
        <div className="flex flex-col justify-center space-y-4 lg:w-1/2">
          <h3 className="text-sm uppercase font-semibold text-gray-600">
            {t("companyName")}
          </h3>
          <h1 className="text-4xl md:text-5xl font-normal text-gray-900 leading-tight">
            {t("headingpart1")} <br />
            {t("headingpart2")} <br />
            {t("headingpart3")}
          </h1>
          <div className="flex space-x-4 mt-4">
            <motion.button
              className="px-6 py-3 bg-gray-900 text-white text-sm font-semibold rounded shadow flex gap-4 items-center group relative overflow-hidden"
              onMouseEnter={handleMouseEnter}
              onClick={handleClick}
              onMouseLeave={handleMouseLeave}
            >
              <span>{t("collaborate")}</span>

              {/* Arrow SVG */}
              <svg
                className="transition-transform group-hover:translate-x-2 rtl:group-hover:-translate-x-2 rtl:rotate-180"
                width="8"
                height="14"
                viewBox="0 0 8 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 13.1831L7 7.18311L1 1.18311"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              {/* Ripple effect */}
              <AnimatePresence>
                {isAnimating && (
                  <motion.span
                    className="absolute w-4 h-4 rounded-full"
                    style={{
                      top: rippleStyle.top,
                      left: rippleStyle.left,
                      backgroundColor: "white",
                    }}
                    initial={{ scale: 0, opacity: 1 }}
                    animate={{ scale: 30, opacity: 0.5 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                  />
                )}
              </AnimatePresence>
            </motion.button>
            <button 
            className="relative px-6 flex flex-col items-center justify-center border-gray-900 text-gray-900 text-sm font-semibold overflow-hidden group"
            onClick={()=>{navigate('/about')}}
            >
              <span className="relative">{t("learnMore")}</span>
              <span className="w-0 h-[2px] bg-gray-900 transition-all duration-300 group-hover:w-full group-hover:left-0"></span>
            </button>
          </div>
        </div>

        {/* Right Section (Image Placeholder) */}
        <div className="mt-8 lg:mt-0 lg:w-2/4 relative h-full z-10">
          <div className="bg-gray-200 h-full rounded-lg grayscale hover:grayscale-0">
            <img
              src="assets/firstpageimage.webp"
              alt=""
              className="object-cover h-full rounded-lg"
            />
          </div>
        </div>

        {/* Full-Width Bottom Section */}
        <div className="w-full relative lg:absolute left-0 bottom-0 p-2 mr-0 mt-4 bg-blue-tint rounded-lg lg:rounded-none text-white z-0">
          <div className="w-full px-4 mx-auto flex items-center">
            {/* Left Aligned Content */}
            <div className="w-full lg:w-1/2 p-2 lg:p-8">
              <h2 className="text-xl font-bold mb-4">{t("whoWeAre")}</h2>
              <p className="text-sm leading-6 text-gray-300">{t("description")}</p>
              <Link
                to="/about"
                className="text-sm font-semibold text-white hover:underline mt-4 inline-block"
              >
                {t("readMore")}
              </Link>
            </div>
            <div className="w-0 lg:w-1/2 h-full"></div>
          </div>
        </div>
      </div>
    </div>
  );
}
